import PresupuestosEstadisticasContainer from './PresupuestosEstadisticasContainer';

export default PresupuestosEstadisticasContainer;
